import { useRef } from 'react';
import YouTube from 'react-youtube';
import SwiperCore, { Pagination } from 'swiper/core';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useUpdateAtom } from 'jotai/utils';
import { currentGalleryIndexAtom, lightboxAtom } from 'global/store';
import styled, { Box } from '@xstyled/styled-components';
import Gallery from './Gallery';
import Image from '@/UI/Image';
import { FlexCenter } from '@/UI/utils';
import { FlexBox } from '@/UI/Primitives/FlexBox';

SwiperCore.use([Pagination]);

const VideoContainer = styled.div`
  margin-top: 4rem;
  align-items: center;
  justify-content: center;
`;

const SwiperContainer = styled.div`
  .swiper-container {
    padding-bottom: 3rem;
  }
`;

const StyledSwiper = styled(Swiper)`
  .swiper-slide {
    ${FlexCenter};
  }

  .swiper-pagination {
    margin-left: -1rem;
  }

  .swiper-pagination-bullet-active {
    background-color: teal-300;
  }
`;

export default function ImageSwiper({ images, product }) {
  const swiperRef = useRef(null);

  const setCurrentIndex = useUpdateAtom(currentGalleryIndexAtom);
  const setLightboxOpen = useUpdateAtom(lightboxAtom);

  return (
    <Box>
      {images?.length > 1 ? (
        <SwiperContainer>
          <StyledSwiper
            ref={swiperRef}
            slidesPerView={1}
            loop
            observer
            pagination={{
              dynamicBullets: true,
              dynamicMainBullets: 3
            }}
          >
            {images?.map((item, i) => {
              return (
                <SwiperSlide
                  key={item.url}
                  onClick={() => {
                    setCurrentIndex(i);
                    setLightboxOpen(true);
                  }}
                >
                  {item.video_content ? (
                    <VideoContainer>
                      <YouTube
                        videoId={item.video_content.video_url.split('v=')[1]}
                        opts={{
                          height: '210px',
                          width: '100%',
                          playerVars: {
                            autoplay: 0
                          },
                          controls: 0
                        }}
                      />
                    </VideoContainer>
                  ) : (
                    <>
                      <Image
                        src={item.url}
                        alt={item.label || product}
                        width={360}
                        height={360}
                        
                      />
                    </>
                  )}
                </SwiperSlide>
              );
            })}
          </StyledSwiper>
        </SwiperContainer>
      ) : (
        <FlexBox
          align="center"
          justify="center"
          onClick={() => setLightboxOpen(true)}
        >
          {images?.map(item => {
            return (
              <Image
                key={item.url}
                src={item.url}
                alt={item.label || product}
                width={360}
                height={360}
              />
            );
          })}
        </FlexBox>
      )}

      {/* Lightbox */}
      <Gallery images={images} />
    </Box>
  );
}
